import "./index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider, useApp } from "./lib/store";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Employees from "./pages/Employees";
import KRA from "./pages/KRA";
import ContentCalendar from "./pages/ContentCalendar";
import DevTasks from "./pages/DevTasks";
import Monthly from "./pages/Monthly";
import Quarterly from "./pages/Quarterly";
import Yearly from "./pages/Yearly";
import Reports from "./pages/Reports";
import Notifications from "./pages/Notifications";
import Settings from "./pages/Settings";
import Growth from "./pages/Growth";
import Shoots from "./pages/Shoots";

function AdminRoute({ children }) {
  const { can } = useApp();
  return can.viewTeam ? children : <Navigate to="/monthly" replace />;
}
function SuperRoute({ children }) {
  const { role } = useApp();
  return role === "super_admin" ? children : <Navigate to="/monthly" replace />;
}

function Shell() {
  const { user, isEmployee } = useApp();
  if (user === undefined) return <div className="min-h-screen flex items-center justify-center text-muted-c">Loading…</div>;
  if (!user) return <Login />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={isEmployee ? <Navigate to="/monthly" replace /> : <Dashboard />} />
        <Route path="/employees" element={<AdminRoute><Employees /></AdminRoute>} />
        <Route path="/kra" element={<KRA />} />
        <Route path="/content-calendar" element={<ContentCalendar />} />
        <Route path="/dev-tasks" element={<DevTasks />} />
        <Route path="/monthly" element={<Monthly />} />
        <Route path="/quarterly" element={<Quarterly />} />
        <Route path="/yearly" element={<Yearly />} />
        <Route path="/growth" element={<AdminRoute><Growth /></AdminRoute>} />
        <Route path="/shoots" element={<AdminRoute><Shoots /></AdminRoute>} />
        <Route path="/reports" element={<AdminRoute><Reports /></AdminRoute>} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/settings" element={<SuperRoute><Settings /></SuperRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <Shell />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
